<template>
  <v-main>
    <div class="d-flex w-full h-full pa-0">
      <OLoadingDialog :value="isLoading" />

      <!-- <div v-if="isLoading && row == null" class="jumbo">
        <v-icon>refresh</v-icon>
        Carregando...
      </div>

      <div v-if="!isLoading && row == null" class="jumbo">
        <v-icon>error_outline</v-icon>
        Cliente não encontrado.
      </div> -->

      <div class="w-250 border-gray border-r-1 bg-gray grow-0 shrink-0">
        <SidebarHeaders :headers="headers" class="mt-1 pa-2" />

        <div class="text-center">
          <span class="tag red text-caption" v-if="row && row.deletedAt">
            Inativo desde {{ row.deletedAt | moment('DD/MM/YYYY') }}
          </span>
        </div>

        <DesktopSideBar :tabItems="tabItems" :currentTab.sync="currentTab" />
      </div>

      <!-- w-0 é um WTF, vide layout.sass -->
      <div class="w-0 grow-1">
        <TabContainer
          v-if="row != null"
          @reload="reload"
          :tabItems="tabItems"
          :currentTab="currentTab"
          :value="row"
        />
      </div>
    </div>
  </v-main>
</template>

<script>
import SidebarHeaders from 'oderon-vue/cpts/tabbed-interface/SidebarHeaders.vue'
import DesktopSideBar from 'oderon-vue/cpts/tabbed-interface/DesktopSideBar.vue'
import TabContainer from 'oderon-vue/cpts/tabbed-interface/TabContainer.vue'
import Store from './Store.js'

export default {
  components: {
    SidebarHeaders,
    DesktopSideBar,
    TabContainer
  },

  // setado pelo vue-router
  props: {
    id: {}
  },

  data() {
    return {}
  },
  computed: {
    currentTab: {
      get() {
        return Store.currentTab
      },
      set(x) {
        Store.currentTab = x
      }
    },
    isLoading() {
      return Store.isLoading
    },
    row() {
      return Store.row
    },
    tabItems() {
      return Store.tabItems
    },

    headers() {
      let result = [
        {
          icon: 'mdi-domain',
          text: this.row && this.row.label,
          primary: true
        }
      ]

      return result
    }
  },

  mounted() {
    this.reload()
  },

  watch: {
    // Quando o cid (da url) muda, avisa o Store.
    id() {
      this.reload()
    }
  },

  methods: {
    reload() {
      Store.load(this.id)
    }
  }
}
</script>

<style></style>
